// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FpsTransferAPIModel
 */
export interface FpsTransferAPIModel {
    /**
     * 
     * @type {string}
     * @memberof FpsTransferAPIModel
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof FpsTransferAPIModel
     */
    sbpId?: string;
    /**
     * 
     * @type {number}
     * @memberof FpsTransferAPIModel
     */
    operationId: number;
}

export function FpsTransferAPIModelFromJSON(json: any): FpsTransferAPIModel {
    return FpsTransferAPIModelFromJSONTyped(json, false);
}

export function FpsTransferAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FpsTransferAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'sbpId': !exists(json, 'sbpId') ? undefined : json['sbpId'],
        'operationId': json['operationId'],
    };
}

export function FpsTransferAPIModelToJSON(value?: FpsTransferAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'sbpId': value.sbpId,
        'operationId': value.operationId,
    };
}


